package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.AndroidWifi3BarAlertW500Rounded: ImageVector
    get() {
        if (_androidWifi3BarAlertW500Rounded != null) {
            return _androidWifi3BarAlertW500Rounded!!
        }
        _androidWifi3BarAlertW500Rounded = Builder(name = "AndroidWifi3BarAlertW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(735.8f, 804.52f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.33f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.32f)
                quadToRelative(-13.18f, 13.18f, -32.33f, 13.18f)
                reflectiveQuadToRelative(-32.33f, -13.18f)
                close()
                moveTo(735.8f, 673.52f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                verticalLineToRelative(-60.0f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.33f)
                verticalLineToRelative(60.0f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.32f)
                quadToRelative(-13.18f, 13.18f, -32.33f, 13.18f)
                reflectiveQuadToRelative(-32.33f, -13.18f)
                close()
                moveTo(309.91f, 310.01f)
                quadToRelative(-82.04f, 27.38f, -151.08f, 80.66f)
                quadToRelative(-21.68f, 17.2f, -49.21f, 16.7f)
                reflectiveQuadToRelative(-46.73f, -19.94f)
                quadToRelative(-18.67f, -18.91f, -18.43f, -46.06f)
                quadToRelative(0.24f, -27.15f, 21.67f, -43.59f)
                quadToRelative(88.48f, -70.71f, 194.2f, -108.31f)
                quadToRelative(105.71f, -37.6f, 219.67f, -37.6f)
                reflectiveQuadToRelative(219.67f, 37.6f)
                quadToRelative(105.72f, 37.6f, 194.2f, 108.31f)
                quadToRelative(21.43f, 16.44f, 21.67f, 43.59f)
                quadToRelative(0.24f, 27.15f, -18.43f, 46.06f)
                quadToRelative(-19.2f, 19.44f, -46.73f, 19.94f)
                quadToRelative(-27.53f, 0.5f, -49.21f, -16.7f)
                quadToRelative(-69.04f, -53.28f, -151.08f, -80.66f)
                quadToRelative(-82.05f, -27.38f, -170.09f, -27.38f)
                reflectiveQuadToRelative(-170.09f, 27.38f)
                close()
                moveTo(419.55f, 782.36f)
                quadToRelative(-25.05f, -25.06f, -25.05f, -60.45f)
                reflectiveQuadToRelative(25.05f, -60.44f)
                quadToRelative(25.06f, -25.06f, 60.45f, -25.06f)
                reflectiveQuadToRelative(60.45f, 25.06f)
                quadToRelative(25.05f, 25.05f, 25.05f, 60.44f)
                reflectiveQuadToRelative(-25.05f, 60.45f)
                quadToRelative(-25.06f, 25.05f, -60.45f, 25.05f)
                reflectiveQuadToRelative(-60.45f, -25.05f)
                close()
                moveTo(480.0f, 524.54f)
                quadToRelative(-39.8f, 0.0f, -77.35f, 10.26f)
                quadToRelative(-37.54f, 10.27f, -71.58f, 30.31f)
                quadToRelative(-23.92f, 14.72f, -51.45f, 13.84f)
                quadToRelative(-27.53f, -0.88f, -46.73f, -20.32f)
                quadToRelative(-18.67f, -18.91f, -18.05f, -45.56f)
                quadToRelative(0.62f, -26.66f, 22.29f, -42.09f)
                quadToRelative(53.48f, -37.48f, 115.2f, -57.34f)
                quadToRelative(61.71f, -19.86f, 127.67f, -19.86f)
                quadToRelative(66.87f, 0.0f, 129.64f, 20.06f)
                quadToRelative(62.77f, 20.05f, 116.21f, 58.92f)
                quadToRelative(-33.31f, 10.28f, -66.62f, 30.2f)
                quadToRelative(-33.32f, 19.91f, -55.27f, 49.54f)
                quadToRelative(-26.72f, -13.48f, -58.34f, -20.72f)
                quadToRelative(-31.62f, -7.24f, -65.62f, -7.24f)
                close()
            }
        }
        .build()
        return _androidWifi3BarAlertW500Rounded!!
    }

private var _androidWifi3BarAlertW500Rounded: ImageVector? = null
